module.exports = __webpack_public_path__ + "images/tips/info-image-02@1x.d554cbf6d240549b8ef0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/info-image-02@1x.png
// module id = OyJe
// module chunks = 24